export const TRACK_CONSTANT_CTA_TRACK_CLICK_NAME = 'Track shipment CTA'
export const TRACK_CONSTANT_CTA_TRACK_CLICK_ZONE = 'my_orders'

export const PARCEL_JOURNEY_TYPE_FORWARD = 'FORWARD'
